/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import {showLoginByPassword, logout} from '../../../common/login/actions';
import {removeErrors} from '../../../common/app/actions';
import {addLog} from '../../../common/logs/actions';
import {isEnv, changeOrganization} from '../../../common/lib/util';
import QuitButton from '../../components/buttons/QuitButton';
import LanguageSwitcher from '../../components/intl/LanguageSwitcher';

class PinKeyboard extends React.Component {

    state: State = {
        value: ''
    };

    static propTypes = {
        msg: React.PropTypes.object,
        onSubmit: React.PropTypes.func.isRequired,
        showLoginByPassword: React.PropTypes.func,
        addLog: React.PropTypes.func,
        logout: React.PropTypes.func,
        error: React.PropTypes.object,
        logTypes: React.PropTypes.object,
        viewer: React.PropTypes.object,
        pinAttempt: React.PropTypes.number,
        organizationName: React.PropTypes.string,
        formDisabled: React.PropTypes.bool,
        showButtonLoginByPassword: React.PropTypes.bool.isRequired
    };

    constructor(props) {
        super(props);

        this.addToTheEnd = this.addToTheEnd.bind(this);
        this.clear = this.clear.bind(this);
        this.logout = this.logout.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.onQuit = this.onQuit.bind(this);
    }

    onQuit(e) {
        if (isEnv(['android_app', 'electron'])) {
            if (typeof window.parent.Ocellot !== 'undefined') {
                window.parent.Ocellot.quit();
            } else {
                window.parent.ocellotQuit();
            }
        }
    }


    componentDidMount() {
        window.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyDown);
    }

    handleKeyDown(e) {
        const {formDisabled: disabled} = this.state;
        if (!disabled) {
            if (['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'].indexOf(event.key) > -1) {
                this.addToTheEnd(event.key);
            } else if ([8, 46].indexOf(event.keyCode) > -1) {
                this.clear();
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        const {pinAttempt} = nextProps;
        if (pinAttempt < 1) {
            this.logout();
        }
    }

    addToTheEnd(x) {
        const {value} = this.state;
        const {onSubmit} = this.props;

        if (value.length >= 4) {
            return;
        }
        const val = value + x;
        this.setState({value: val});
        if (val.length === 4) {
            onSubmit(val);
            this.clear();
        }
    }

    clear() {
        this.setState({value: ''});
    }

    componentWillMount() {
        const {removeErrors} = this.props;
        removeErrors();
    }

    logout() {
        const {logout, showLoginByPassword, addLog, viewer, logTypes} = this.props;
        logout();
        addLog(logTypes.LOGOUT_POS, viewer.get('userId'));
        showLoginByPassword();
    }

    render() {
        const {error, showLoginByPassword, formDisabled: disabled, showButtonLoginByPassword, organizationName, msg} = this.props;
        const {value} = this.state;

        return (
            <div className="keyboardPanel">
              <div className="keyboardPanel-panel">
                <h1 className="pageLogin-logo">
                    {msg.global.appName} {!!organizationName && `- ${organizationName}`}
                </h1>
                {isEnv(['android_app', 'electron']) && showButtonLoginByPassword &&
                <div className="change-org">
                    <span onClick={() => changeOrganization()}>{msg.pin.changeOrg}</span>
                </div>
                }
                {isEnv(['android_app', 'electron']) && showButtonLoginByPassword &&
                <button className="btn btn-danger btn-quit" onClick={this.onQuit}><QuitButton/></button>
                }
                <LanguageSwitcher/>
                <div className="keyboardPanel-rpw">
                        <span className="keyboardPanel-label">{msg.pin.pin}</span>
                        <input type="password" className="keyboardPanel-input" value={value} readOnly/>
                    {!!error &&
                    <div className="keyboardPanel-errors">
                        <div className="errors">
                            <ul>
                                {error.map((err, i) =>
                                    <li key={`error-key-${i}`}>{err}</li>
                                )}
                            </ul>
                        </div>
                    </div>
                    }
                </div>
              </div>
                <div className="keyboardPanel-keyboard">
                    <div className="keyboardPin">
                        <div className="keyboardPin-keys">
                            {['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'].map((x, i) =>
                              <div className="keyboardPin-key" key={`numerical-key-${i}`}>
                                <div
                                     className={`boxBtn text-l color-white ${disabled ? 'disabled' : ''}`}
                                     onClick={() => this.addToTheEnd(x)}>
                                    <div className="boxBtn-inner">
                                        <span>{x}</span>
                                    </div>
                                </div>
                              </div>
                            )}
                            <div className="keyboardPin-key view-big">
                              <div className={`boxBtn color-red ${disabled ? 'disabled' : ''}`}
                                   onClick={this.clear}>
                                  <div className="boxBtn-inner">
                                    <svg className={`shape shape-backspace`}>
                                      <use xlinkHref={`#shape-backspace`}></use>
                                    </svg>
                                  </div>
                              </div>
                            </div>
                        </div>
                      <div className="keyboardPin-controls">

                        <div className="keyboardPin-controls-key">
                        </div>

                        <div className="keyboardPin-controls-key">
                        {showButtonLoginByPassword &&
                        <div className={`boxBtn text-l color-green ${disabled ? 'disabled' : ''}`}
                             onClick={showLoginByPassword}>
                          <div className="boxBtn-inner">
                            <span>{msg.pin.passwordLogin}</span>
                          </div>
                        </div>
                        }
                        {!showButtonLoginByPassword &&
                        <div className={`boxBtn text-l color-red ${disabled ? 'disabled' : ''}`}
                             onClick={this.logout}>
                          <div className="boxBtn-inner">
                                <span>
                                    {msg.global.logout}
                                </span>
                          </div>
                        </div>
                        }
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    formDisabled: state.login.get('formDisabled'),
    error: state.app.get('error'),
    organizationName: state.device.get('organizationName'),
    viewer: state.users.get('viewer'),
    pinAttempt: state.users.get('pinAttempt'),
    logTypes: state.logs.logTypes
}), {showLoginByPassword, removeErrors, logout, addLog})(PinKeyboard);



// WEBPACK FOOTER //
// ./src/browser/components/keyboard/PinKeyboard.js